import type { TBlueObj } from "@app/types/insider";
export const uiPersistInvoiceGrid: TBlueObj<unknown> = {
  name: "uiPersistInvoiceGrid",
  initialState: {},
  starfx: true,
  idb: false,
  bootPriority: 0,
};

export const uiPersistSpvList: TBlueObj<unknown> = {
  name: "uiPersistSpvList",
  initialState: {},
  starfx: true,
  idb: false,
  bootPriority: 0,
};

export const persitorGuardian: TBlueObj<{ email: string; perseed: string }> = {
  name: "persitorGuardian",
  initialState: {
    email: "",
    perseed: "",
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};
